// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"8c691092","395":"f42f5518","899":"4bfc9478"}[chunkId] + ".chunk.js";
};